// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wheeldiv[data-v-32071e13]{display:grid;grid-template-columns:1fr 4fr 1fr;grid-template-rows:1fr 1fr}", ""]);
// Exports
module.exports = exports;
